import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { getServerErrorNotificationKey } from '../../../../utils/validation'

export function useTableItemUpdate({ api, onAddNotification, onReload }) {
  const { t } = useTranslation()

  async function updateItem({ data, errorText, id, successText }) {
    return api(data, id)
      .then(() => {
        onReload(id)

        if (successText) {
          onAddNotification({
            title: t(successText),
            type: NOTIFICATION_TYPE.success,
          })
        }

        return data
      })
      .catch(error => {
        const errorKey = getServerErrorNotificationKey(
          error?.response?.data,
          errorText
        )

        if (errorKey) {
          onAddNotification({
            title: t(errorKey),
            type: NOTIFICATION_TYPE.error,
          })
        }
      })
  }

  return { updateItem }
}
